var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.muted)?_c('div',{directives:[{name:"log",rawName:"v-log",value:({
    type: 'show',
    name: 'PHOTO_CARD_SPECIAL',
    value: {
      button_type: 'muted',
      card_type: _vm.cardType
    }
  }),expression:"{\n    type: 'show',\n    name: 'PHOTO_CARD_SPECIAL',\n    value: {\n      button_type: 'muted',\n      card_type: cardType\n    }\n  }"}],class:['muted-contro', { open: _vm.isOpenButton }],on:{"click":function($event){$event.preventDefault();return _vm.setUnMuted.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("../../images/mute.svg")}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('k_468684')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }